<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li>通讯录</li>
                <li><a href="#">短信审核列表</a></li>
            </ul>
        </div>
        <div id="usual1" class="usual">  
            <div class="formbody">            
            <table class="tablelist" style="border-collapse:collapse;table-layout:fixed;">
                <thead>
                <tr>
                    <th width="20%">号码</th>
                    <th width="35%">内容</th>
                    <th width="5%">通道号</th>
                    <th width="5%">计费条数</th>
                    <th width="10%">提交时间</th>
                    <th width="10%">状态</th>
                    <th width="5%">操作</th>
                </tr>
                </thead>
                <tbody>
                
                <tr v-for="(item,index) in smsCheckList" :class="{odd:index%2!=0}">
                    <td width="20%" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" v-if="item.format=='txt'" title="点击下载文件">号码文件：<a href="javascript:;" @click="download(item.id)">{{item.srcfilename}}</a><br/><font color="green">普通短信</font></td>
                    <td width="20%" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" v-else-if="item.format=='gexing'" title="点击下载文件">
                        号码文件：<a href="javascript:;" @click="download(item.id)">{{item.srcfilename}}</a><br/>
                        <font color="green" v-if="item.smsid.indexOf('short_')!=-1">短地址群发短信</font>                        
                        <font color="green" v-else>个性短信</font>
                    </td>
                    <td v-else-if="item.format=='phone' && item.smsid.indexOf('videosms_')!=-1" width="30%" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" :title="item.mobile">{{item.mobile}}<br/><font color="green">视频短信</font></td>
                    <td v-else width="30%" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" :title="item.mobile">{{item.mobile}}<br/><font color="green">普通短信</font></td>
                    
                    <td width="35%" v-if="item.format=='phone' && item.smsid.indexOf('videosms_')!=-1" >
                        标题：{{item.content.substring(0,item.content.indexOf('|'))}}<br/>
                        模板编号：{{item.content.substring(item.content.indexOf('|')+1)}}
                    </td>
                    <td width="35%" v-else >{{item.content}}</td>
                    <td width="5%" :title="item.channel">{{item.channel}}</td>
                    <td width="5%" >{{item.num}}</td>
                    <td width="10%" :title="item.createdate">{{item.createdate}}</td>
                    <td width="10%" :title="item.demo">
                        <ol v-if="item.status == 0">未审核</ol>
                        <ol v-else-if="item.status == 1">审核通过</ol>
                        <ol style="color:red" v-else-if="item.status == 2">审核不通过<br/>{{item.demo}}<br/><a target="_blank" href="http://wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDAyMDIxNF80ODkyNjJfODAwMDIwMjE0XzJf"><img border="0" src="http://wpa.qq.com/pa?p=2:800020214:41" alt="点击咨询" title="点击咨询"/></a></ol>
                        <ol style="color:#8D32FE;" v-else-if="item.status == 3">未提交,{{item.demo}}</ol>
                        <ol v-else-if="item.status == 4"> 含关键字，不发</ol>
                        <ol v-else-if="item.status == 5"> 撤回</ol>
                    </td>
                    <td width="5%">
                        <ol v-if="item.status == 0"><a href="#" style="color:blue;" @click="revocationSms(item.id)">撤回</a></ol>
                        <ol v-else-if="item.status == 5"><a href="#" style="color:rgb(212, 0, 255);" @click="smsResend(item.mobile,item.content,item.format, item.num, item.srcfilename)">重发</a></ol>
                        <ol v-else>--</ol>
                    </td>
                </tr>
                </tbody>
            </table>
            <div class="pagin">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageIndex"
                    :page-sizes="[50]"
                    :page-size="50"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount">
                </el-pagination>
            </div>
            <div class="jian">&nbsp;</div>        
            </div> 

            <div style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.3; 
                top: 0; left: 0;display: block;" v-show="loadingShow"></div>
            <div style="position:fixed; left: 50%; top:50%; transform: translate3d(-50%, -50%, 0px); -ms-transform: translate3d(-50%, -50%, 0px);
                -webkit-transform: translate3d(-50%, -50%, 0px); z-index: 10000;" v-show="loadingShow">
                <i class="el-icon-loading" style="font-size: 40px;color:coral;"></i>
                <div style="margin-left:-20px;color:coral;"><span style="font-size: 13px;">查询中,请稍后...</span></div>
            </div>

        </div> 
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            pageIndex:0,
            totalCount:0,
            smsCheckList:[],
            loadingShow: true,
        }
    },
    mounted(){
        this.pageChange(1);
    },
    methods:{
        handleSizeChange(val){
            this.pageChange(val);
        },
        handleCurrentChange(val){
            this.pageChange(val);
        },
        pageChange(pageIndex){
            this.loadingShow = true;
            let that = this;
            let data = {'pageSize':50,pageIndex:pageIndex};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/getpagesmscheck.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.smsCheckList = res.data.smsblackcontentList;
                    that.pageIndex = parseInt(pageIndex);
                    that.totalCount = res.data.page.totalCount;
                    that.loadingShow = false;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        download(id){
            window.open(this.GLOBAL.serverSrc + "/sms/downloadsmsblackcontenttxt.json?token=" + this.GLOBAL.token + "&id=" + id)
        },
        revocationSms(id)
        {
            var that = this
            let param = {"ids":id}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/sms/revocationsms.json?token=" + this.GLOBAL.token,
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {                    
                    that.$alert("此短信撤回成功！")
                }
                else if("0030006" == res.data.code)
                {
                    that.$alert("此短信已经被二办客服处理，不能再撤回！");
                }
                else
                {
                    that.$alert(res.data.msg)
                }
                that.pageChange(1);
            })
        },
        smsResend(mobile,content,format, mobileNum, srcfilename)
        {
            if('txt' == format)
            {
                this.$router.push({
                    path: '/smssend',
                    query: {
                        mobile: '您的号码文件' + srcfilename + '上传成功,请填写内容发送.',
                        content: content,
                        mobileNum: mobileNum,
                        txtpath: mobile,
                        format:format,
                        srcfilename:srcfilename
                    }
                })
            }
            else
            {
                this.$router.push({
                    path: '/smssend',
                    query: {
                        mobile: mobile,
                        content: content,
                        mobileNum: mobileNum,
                        txtpath: '',
                        format:format,
                        srcfilename:srcfilename
                    }
                })
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/sms/smscheck.vue